import { environment } from '@environments/environment';
import { createApiConfiguration } from '@fagforbundet/ngx-components';
import { ProxyApiEndpoints } from '@config/apis/proxy/proxy-api-endpoints';

export const proxyApiConfig = createApiConfiguration<typeof ProxyApiEndpoints>({
  baseUrl: environment.apis.proxy.baseUrl,
  endpoints: ProxyApiEndpoints,
});
